/**
 * @tabler/icons-react v2.1.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEyeOff = createReactComponent("eye-off", "IconEyeOff", [
  ["path", { d: "M3 3l18 18", key: "svg-0" }],
  ["path", { d: "M10.584 10.587a2 2 0 0 0 2.828 2.83", key: "svg-1" }],
  [
    "path",
    {
      d: "M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341",
      key: "svg-2"
    }
  ]
]);

export { IconEyeOff as default };
//# sourceMappingURL=IconEyeOff.js.map
